import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export type PromptVariant = 'lightweight' | 'focused' | 'full';

interface PromptVariantSelectorProps {
  value: PromptVariant;
  onChange: (variant: PromptVariant) => void;
}

export const PromptVariantSelector = ({ value, onChange }: PromptVariantSelectorProps) => {
  return (
    <div className="flex items-center gap-2 px-4 py-2 border-b border-white/10">
      <label className="text-xs text-white/60 font-medium">Prompt Style:</label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[200px] h-8 text-xs bg-white/5 border-white/10 hover:bg-white/10 transition-colors">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-gray-900 border-white/10">
          <SelectItem value="lightweight" className="text-xs cursor-pointer hover:bg-white/10">
            Lightweight (Fast)
          </SelectItem>
          <SelectItem value="focused" className="text-xs cursor-pointer hover:bg-white/10">
            Focused (Balanced) ⭐
          </SelectItem>
          <SelectItem value="full" className="text-xs cursor-pointer hover:bg-white/10">
            Full (Most Precise)
          </SelectItem>
        </SelectContent>
      </Select>
      <div className="text-xs text-white/40 ml-2">
        {value === 'lightweight' && '2-3 prompts, simple descriptions'}
        {value === 'focused' && '3-4 prompts, structured approach'}
        {value === 'full' && '4-5 prompts, maximum detail'}
      </div>
    </div>
  );
};
